import { createFileRoute } from '@tanstack/react-router'
import { HrPage } from '@/features/hr/ui/hr-page'
import { PageLayout } from '@/components/page-layout'

export const Route = createFileRoute('/_authenticated/hr/')({
	component: () => {
		return (
			<PageLayout data-id='hr-page'>
				<HrPage />
			</PageLayout>
		)
	},
})
